import EventEmitter from 'event-emitter3'

export default new EventEmitter()
